import React from 'react'
import "./footer.css"


const Footer = () => {
    return (
        <div id="footer">
            <div className="end">
            </div>
            
            <div className="end-msg">
                <span className="depth">
                    Areeb&nbsp;ur&nbsp;Rub's<br/>Portfolio 
                </span>
            </div>
            
        </div>
    )
}

export default Footer
